module.exports = __webpack_public_path__ + "static/media/bg.17c69724.png";